import React from 'react';
import Image from 'next/image';
import { useArticleById } from './hooks/useArticleById';
import dayjs from 'dayjs';
import timeIcon from '../../../public/time_Icon.svg';

export const FaqArticle = () => {
  const { article: articles } = useArticleById(2916);
  const url = articles?.link.replace('https://fukudake3ea3cd852.wpcomstaging.com', '');
  const formattedDate = dayjs(articles?.modified).format('YYYY年MM月DD日');
  return (
    <div className="border border-gray-300 mt-2">
      <a href={'https://raysee.jp/column/' + url} className="flex p-2" target="_blank">
        <Image
          src={articles?.jetpack_featured_media_url || '/path-to-fallback-image.png'}
          alt="記事のサムネイル画像"
          width={120}
          height={80}
          className="object-cover"
        />
        <div className="pl-4">
          <p className="font-bold text-sm leading-6">{articles?.title.rendered}</p>
          <div className="flex mb-1 pt-4">
            <Image src={timeIcon} width={12} height={12} alt="" />
            <p className="pl-1 text-xs">{formattedDate}</p>
          </div>
        </div>
      </a>
    </div>
  );
};
